export const playMediaSafely = (
  mediaElement: HTMLMediaElement | null | undefined,
  onError?: (error: unknown) => void,
) => {
  if (!mediaElement) return;

  try {
    const playResult = mediaElement.play();
    if (playResult && typeof playResult.catch === 'function') {
      void playResult.catch((error) => {
        onError?.(error);
      });
    }
  } catch (error) {
    onError?.(error);
  }
};
